import baseBackendApi from "../main/configuration/baseBackendApi";

export const getSongsForRequestDeletion = async () => {
    const response = await baseBackendApi.get("songs");
    return response;
}